import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/loader/vans.gif")